// @flow

import React from 'react';

import { urlWithNext } from 'app/common/utils/UrlUtils';

type LoginDifferentProps = {
  isPlatformLogin?: boolean,
  next: string,
};

const LoginDifferent = ({ isPlatformLogin, next }: LoginDifferentProps) => {
  const baseUrl = isPlatformLogin ? 'platform' : 'app';
  next = urlWithNext(`/${baseUrl}/login`, next);
  const logoutHref = urlWithNext('/logout/', next);
  return (
    <div>
      <p>{<a href={logoutHref}>Log in as a different user</a>}</p>
    </div>
  );
};

export default LoginDifferent;
